export default __webpack_public_path__ + "static/cat-308ae9ee2df8b6399a0b0e2615fa4702.webp";